var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._g({staticClass:"svg-icon",style:({ color: _setup.color, '--svg-light-color': _setup.bgColor }),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":'#' + _setup.iconId,"fill":_setup.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }